import { InvestmentGoalsMaxRecoveryPeriod } from '../../../../types';
export var list = [
    InvestmentGoalsMaxRecoveryPeriod.LESS_THAN_ONE_YEAR,
    InvestmentGoalsMaxRecoveryPeriod.BETWEEN_ONE_AND_THREE_YEARS,
    InvestmentGoalsMaxRecoveryPeriod.MORE_THAN_THREE_YEARS,
];
